import { trackEvent } from "@/lib/audit";
import { awardPoints } from "@/lib/gamification";

const KEY = "onboarding_completed";

export function isOnboardingCompleted(): boolean {
  if (typeof window === "undefined") return true;
  try {
    return window.localStorage.getItem(KEY) === "true";
  } catch {
    return false;
  }
}

export function markOnboardingCompleted() {
  try {
    window.localStorage.setItem(KEY, "true");
  } catch {
    /* noop */
  }
}

export function resetOnboarding() {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* noop */
  }
}

export const onboardingAudit = {
  started: () => void trackEvent("onboarding_started", {}),
  step: (step: number, title: string) =>
    void trackEvent("onboarding_step_viewed", { step, title }),
  completed: () => {
    void trackEvent("onboarding_completed", {});
    void awardPoints("onboarding_completed");
  },
  skipped: (step: number) => void trackEvent("onboarding_skipped", { step }),
  reopened: () => void trackEvent("onboarding_reopened", {}),
};